import React from 'react';

interface ClearIconProps {
    width?: number | string;
    height?: number | string;
    fill?: string;
}

export const ClearIcon: React.FC<ClearIconProps> = ({
    width = 22,
    height = 24,
    fill = '#E30613',
}) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 22 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M9.66211 21.0874C10.8256 20.0951 11.37 19.4356 12.1621 18.0874"
                stroke={fill}
                strokeLinecap="round"
            />
            <path
                d="M16.9238 1.84764C17.4969 0.773177 18.7967 0.316334 19.916 0.795886C21.2219 1.35561 21.7346 2.93881 21.0039 4.15721L17.6631 9.72362C18.348 10.8487 18.5571 12.305 18.3389 13.624C17.8288 16.7066 16.6872 19.2148 14.502 22.6982C14.1366 23.2801 13.4153 23.5373 12.7637 23.3135C7.69044 21.5687 5.10006 19.8321 2.1875 16.4892C1.49628 15.6955 1.84812 14.4921 2.7959 14.1289C6.06769 12.8756 7.99622 11.8659 10.1865 9.58593C11.115 8.6194 12.3766 7.82741 13.7705 7.75682L16.9238 1.84764ZM9.5293 11.5801C7.69411 13.1423 5.82925 14.0388 3.1543 15.0635C2.82017 15.1915 2.73137 15.5903 2.94141 15.832C3.73771 16.746 4.50762 17.5307 5.31348 18.2285C5.33609 18.2066 5.36133 18.1868 5.38867 18.1689C5.74553 17.9362 5.98377 17.7609 6.17969 17.5693C6.3715 17.3818 6.53771 17.1637 6.73047 16.8349C6.87011 16.5967 7.17682 16.5166 7.41504 16.6562C7.65315 16.7959 7.73332 17.1026 7.59375 17.3408C7.36862 17.7248 7.14989 18.0192 6.87891 18.2842C6.65635 18.5018 6.40763 18.6883 6.11523 18.8857C7.93232 20.2814 10.0301 21.3152 13.0889 22.3672C13.2993 22.4394 13.535 22.356 13.6543 22.166C15.3377 19.4825 16.3553 17.4411 16.9492 15.29L9.5293 11.5801ZM14.5088 8.80077C13.2227 8.56237 11.9207 9.22445 10.9082 10.2783C10.7127 10.4818 10.5171 10.6739 10.3242 10.8594L17.1934 14.2939C17.2517 14.0201 17.3058 13.7432 17.3525 13.4609C17.6929 11.4036 16.8259 9.36421 15.04 8.916C14.8682 8.8729 14.6912 8.83459 14.5088 8.80077ZM2.16211 9.08788C2.99054 9.08788 3.66211 9.75945 3.66211 10.5879C3.66197 11.4162 2.99045 12.0879 2.16211 12.0879C1.33377 12.0879 0.66225 11.4162 0.662109 10.5879C0.662109 9.75945 1.33368 9.08788 2.16211 9.08788ZM19.5225 1.71483C18.8805 1.43969 18.1344 1.70204 17.8057 2.31835L14.8555 7.8496C15.0005 7.87899 15.1435 7.91098 15.2842 7.94628C15.9729 8.1192 16.542 8.45093 16.998 8.88866L20.1455 3.64257C20.5647 2.94375 20.2715 2.03589 19.5225 1.71483ZM4.66211 6.08788C5.21439 6.08788 5.66211 6.53559 5.66211 7.08788C5.66197 7.64004 5.21431 8.08788 4.66211 8.08788C4.10991 8.08788 3.66225 7.64004 3.66211 7.08788C3.66211 6.53559 4.10982 6.08788 4.66211 6.08788Z"
                fill={fill}
            />
        </svg>
    );
};
